export enum PAGE_TITLE {
  ZIP_UTILS = 'Zip-Utils',
  ZIP_TEXT = 'Text Uploader',
  ZIP_URL = 'URL Shortener',
  ZIP_QR = 'QR Code Generator',
  ZIP_FILE = 'File Transfer',
  NOT_FOUND = 'Page Not Found!',
}

export enum PAGE_DESCRIPTION {
  ZIP_UTILS = '⚡ ZipUtils is a free online utility platform to securely transfer text, shorten long URLs, and generate QR codes instantly. All tools work directly in your browser with a focus on speed, privacy, and simplicity. 🔒',
  ZIP_TEXT = '💬 Paste and share instantly with a unique, secure link. 🔒',
  ZIP_URL = '🔗 Create short, simple, and shareable links in seconds.',
  ZIP_QR = '📱 Generate QR codes for links, text, or data — in one click.',
  ZIP_FILE = '📁 Upload and share files securely with a temporary download link. 🔒',
  NOT_FOUND = 'The page you are looking for does not exist or may have been moved.',
}

export enum RedirectionType {
  TEXT = 't',
  URL = 'u',
  QR = 'q',
}

export enum GraphQLRedirectionType {
  TEXT = 'TEXT',
  URL = 'URL',
  QR = 'QR',
}

export enum TAB_TITLE {
  ZIP_TEXT = 'Online Text Transfer Tool – Secure Text Uploader | ZipUtils',
  ZIP_URL = 'URL Shortener – Create Short Links Instantly | ZipUtils',
  ZIP_QR = 'QR Code Generator – Create QR Codes for Links or Text | ZipUtils',
}

export enum COMPONENT_TITLE {
  ZIP_TEXT = 'Text Transfer Online – Secure Text Uploader',
  ZIP_URL = 'URL Shortener – Create Short Links Instantly',
  ZIP_QR = 'QR Code Generator – Create QR Codes for Links or Text',
}

export enum COMPONENT_DESCRIPTION {
  ZIP_TEXT = '💬 ZipUtils Text Transfer is an online text sharing tool that lets you paste text and instantly generate a secure, shareable link. Upload text, generate a private link, and share it instantly with automatic expiry. 🔒',
  ZIP_URL = '🔗 Shorten long URLs instantly with ZipUtils. Create clean, shareable short links that are fast, reliable, and easy to use. ⚡',
  ZIP_QR = '📱 Generate QR codes for links, text, or data — in one click.',
}

export enum OPEN_GRAPH_TITLE {
  ZIP_TEXT = 'Text Uploader | ZipUtils',
  ZIP_URL = 'URL Shortener | ZipUtils',
  ZIP_QR = 'QR Code Generator | ZipUtils',
}
